<template>

<app-page>

	<router-view></router-view>

</app-page>

</template>

<script>

export default {

}

</script>

<style scoped>

</style>